module.exports = __webpack_public_path__ + "img/celeb.427ac699.svg";